// Phase 4 / P4c — Benchmark endpoint wrapper.
import { api } from "../api";

export const getBusinessHealthBenchmark = async () =>
  (await api.get("/benchmarks/business_health")).data;
